export default __webpack_public_path__ + "static/media/about3.97bf68fc.png";